import { prefixClass } from 'lib/utils';
import './LabelSwitchItem.scss';
import classNames from 'classnames';
import { Tooltip, Whisper } from 'rsuite';

type LabelSwitchButtonProps = {
  label: string;
  selected?: boolean;
  disabled?: boolean;
  type?: 'Normal' | 'Blocker' | 'Closed' | 'Open' | 'In Progress';
  tooltip?: string;
  onClick?: () => void;
  pulse?: boolean;
  badge?: string;
};

const LabelSwitchItem = (props: LabelSwitchButtonProps) => {
  const { label, selected = false, disabled = false, type, onClick, pulse, badge } = props;
  const prefix = prefixClass('label-switch-item');

  const handleClick = () => {
    if (disabled) return;
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={classNames(prefix())} onClick={handleClick}>
      <Whisper trigger="hover" placement="top" delay={300} speaker={<Tooltip>{props.tooltip}</Tooltip>}>
        <div
          className={classNames(prefix('label'), {
            'lsi-selected': selected,
            'lsi-disabled': disabled,
            'lsi-normal-color': type === 'Normal',
            'lsi-blocker-color': type === 'Blocker',
            'lsi-closed-color': type === 'Closed',
            'lsi-open-color': type === 'Open',
            'lsi-in-progress-color': type === 'In Progress',
            'lsi-pulse-target': pulse,
          })}
        >
          {label}
          {pulse && badge && <span className="pulse-badge">{badge}</span>}
        </div>
      </Whisper>
    </div>
  );
};

export default LabelSwitchItem;
